import React, { memo } from "react";
import { validators } from "investira.sdk";
import { Stack, Card, CardHeader, CardContent } from "investira.react.components";
// import AtivosChart from "./AtivosChart";
// import SetoresChart from "./SetoresChart";
import CenariosChart from "./CenariosChart";
const Graphs = memo(props => {
  const {
    data = []
  } = props;
  const xResumo = data.response?.resumo;
  if (validators.isNull(xResumo)) {
    return null;
  }
  return <Stack direction={{
    xs: "column",
    md: "row"
  }} sx={{
    flex: 1,
    minHeight: 0 // Importante para flexbox
  }} py={1}>
      <Stack direction={{
      xs: "column",
      md: "row"
    }} gap={2} sx={{
      width: "100%",
      height: "100%",
      minHeight: "300px",
      isolation: "isolate"
    }}>
        <Card sx={{
        flex: 1,
        minHeight: 0
      }}>
          <CardHeader title="Cenários" titleTypographyProps={{
          variant: "h6"
        }} />
          <CardContent sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          minHeight: "200px"
        }}>
            <CenariosChart data={xResumo.impacto.cenarios} />
          </CardContent>
        </Card>
      </Stack>
    </Stack>;

  // return (
  //   <Stack sx={{ gap: 2 }} component="section">
  //     <Stack spacing={2}>
  //       <Card sx={{ height: "100%" }}>
  //         <CardContent
  //           sx={{
  //             display: "flex",
  //             flexDirection: "column",
  //             justifyContent: "space-between",
  //             height: "100%",
  //             minHeight: "200px",
  //           }}
  //         >
  //           <Stack direction="row">
  //             <Stack flexGrow={1} alignItems="center" justifyContent="center">
  //               <ToggleButtonGroup
  //                 color="primary"
  //                 value={alignment}
  //                 exclusive
  //                 onChange={handleChange}
  //               >
  //                 <ToggleButton
  //                   value="ativo"
  //                   sx={{
  //                     whiteSpace: "nowrap",
  //                     padding: "4px 8px",
  //                     fontSize: "0.75rem",
  //                   }}
  //                 >
  //                   Tipos de Ativos
  //                 </ToggleButton>
  //                 <ToggleButton
  //                   value="emissores"
  //                   sx={{ padding: "4px 8px", fontSize: "0.75rem" }}
  //                 >
  //                   Emissores
  //                 </ToggleButton>
  //                 <ToggleButton
  //                   value="setores"
  //                   sx={{ padding: "4px 8px", fontSize: "0.75rem" }}
  //                 >
  //                   Setores
  //                 </ToggleButton>
  //                 <ToggleButton
  //                   value="gestores"
  //                   sx={{ padding: "4px 8px", fontSize: "0.75rem" }}
  //                 >
  //                   Gestores
  //                 </ToggleButton>
  //               </ToggleButtonGroup>
  //             </Stack>
  //           </Stack>
  //           <Stack
  //             direction={{ xs: "column", md: "row" }}
  //             sx={{
  //               flex: 1,
  //               minHeight: 0, // Importante para flexbox
  //             }}
  //             py={1}
  //           >
  //             <Stack
  //               sx={{
  //                 width: "100%",
  //                 height: "100%",
  //                 minHeight: "300px",
  //                 isolation: "isolate",
  //               }}
  //             >
  //               {alignment === "ativo" && <AtivosChart data={xResumo.ativos} />}

  //               {alignment === "setores" && (
  //                 <SetoresChart data={xResumo.setores} />
  //               )}

  //             </Stack>
  //           </Stack>
  //         </CardContent>
  //       </Card>
  //     </Stack>
  //   </Stack>
  // );
});
export default Graphs;
